export default __webpack_public_path__ + "static/VehicleCompare-b114ccc0f6c2fa8f22254c994f1e9f3e.jpg";